import React from "react";
import { VStack } from "@chakra-ui/react";
import { TableList } from "../component/Instance/TableList";

export const Home = () => {
   return (
      <VStack align="stretch" spacing={5}>
         <TableList />
      </VStack>
   );
};
